import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchAndSetIpAddress = createAsyncThunk(
  'ip/fetchIpAddress',
  async (_, { dispatch }) => {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    dispatch(setIpAddress(data.ip));
    return data.ip;
  }
);

const ipSlice = createSlice({
  name: 'ip',
  initialState: {
    ipAddress: null,
  },
  reducers: {
    setIpAddress: (state, action) => {
      state.ipAddress = action.payload;
    },
  },
});

export const { setIpAddress } = ipSlice.actions;
export default ipSlice.reducer;
